import { FC } from 'react';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import { cn } from '@/utils/classNames.ts';

const Separator: FC<PropsWithClassName> = ({ className }) => {
  return <div className={cn('h-[1px] min-h-[1px] bg-primary bg-opacity-25', className)}></div>;
};

export default Separator;
